<template>
  <div class="tinkSlideItem" :id="'tinkListItem_' + _uid">
    <slot></slot>
  </div>
</template>
<script>
import uiUtil from "@/mixins/util.js"

export default {
  name: "tinkListItem",
  props: {
    "show": {
      type: Boolean,
      default: false
    },
    "name": {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.$el.style.display = "none"
    this.$parent.items.push(this)
  },
  updated() {
  }
}
</script>
<style scoped>
  .tinkSlideItem { display: none; }
</style>
